/**
 * Raster operation type. Supported values are `'pixel'` and `'image'`.
 * @enum {string}
 */
var _ol_source_RasterOperationType_ = {
  PIXEL: 'pixel',
  IMAGE: 'image'
};

export default _ol_source_RasterOperationType_;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ol/source/rasteroperationtype.js
// module id = ../../../../ol/source/rasteroperationtype.js
// module chunks = vendor